<template>
	<div class="main-content login-background">
        <div class="tab" :class="{'hide':!this.loginTab}">
            <h1>Login</h1>
            <input class="tube-input" v-model="mail" placeholder="Mail" type="text">
            <div class='blank'></div>
            <input class="tube-input" v-model="passwd" type="password" placeholder="Password">
            <div class='blank'></div>
            <button class="wide tube-button" @click="login">login</button>
        </div>
        <div class="tab" :class="{'hide':this.loginTab}">
            <h1>Register</h1>
            <input class="tube-input" v-model="username" placeholder="username" type="text" :disabled='sending'>
            <div class='blank'></div>
            <input class="tube-input" v-model="mail2" placeholder="mail" type="text" :disabled='sending'>
            <div class='blank'></div>
            <input class="tube-input" v-model="passwd2" placeholder="passwd" type="password" :disabled='sending'>
            <div class='blank'></div>
            <input class="tube-input" v-model="des" placeholder="des" type="text" :disabled='sending'>
            <div class='blank'></div>
            <button class="wide tube-button" @click="register" :disabled='sending'>register</button>
        </div>
        <div class='blank'></div>
        <div class='assistButton'>
            <button class="tube-button" @click='help'>help</button>
            <button class="tube-button" @click="tabSwitch">{{this.tabButtonName}}</button>
        </div>
        <div class="version">Tube(Truly Ultra-fast Binding Experience) 1.0.0</div>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
	name: 'Login',
	data:function(){
		return {
            mail:'',
            passwd:'',
            username:'',
            mail2:'',
            passwd2:'',
            des:'',
            sending:false,
            loginTab:true
		}
    },
    methods:{
        login(){
            let need2Recap=false;
            let ChatLog=[];
            if(this.$store.state.chats){
                need2Recap=true;
                let count=0;
                while(this.$store.state.chats[count]){
                    let perChat={};
                    perChat.cid=this.$store.state.chats[count].cid;
                    perChat.lastUpdateDatetime=this.$store.state.chats[count].lastUpdateDatetime;
                    ChatLog.push(perChat);
                    count++;
                }
            }
            this.$store.commit('login',{userMail:this.mail,userPasswd:this.passwd});
            this.$emit('user-login',{id:this.mail,password:this.passwd,groupRecap:(need2Recap)?ChatLog:null});
        },
        register(){
            if(this.username.trim()!=='' && this.mail2.trim()!=='' && this.passwd2.trim()!=='' && this.des.trim()!==''){
                // Ajax call here
                this.sending=true;
                this.axios
                    .post(this.$store.state.baseUrl+'/register',{
                        username:this.username,
                        mail2:this.mail2,
                        passwd2:this.passwd2,
                        des:this.des
                    })
                    .then(res=>{
                        // console.log(res.data);
                        if(res.data.result===1){
                            alert('registered successfully!');
                            console.log('success');
                            this.loginTab=true;
                        }else if(res.data.result===2){
                            alert('fail to register!');
                            console.log('error');
                        }
                        this.username='';
                        this.mail2='';
                        this.passwd2='';
                        this.des='';
                        this.sending=false;
                    })
                    .catch(err=> {
                        console.log(err);
                    });
            }else{
                console.log('not all filled');
            }
        },
        tabSwitch(){
            this.loginTab = !this.loginTab;
        },
        help(){
            alert('If you haven\'t registered yet, please press the register button to register first');
        }
    },
    computed:{
        tabButtonName(){
            return (this.loginTab)? 'register':'login';
        }
    }
}
</script>

<style>
    .login-background{
        align-content: center;
        justify-content:center;
        align-items: center;
        min-height: 70vh;
        width: 100vw;
    }

    .tube-input {
        border-radius: 4px;
        height:32px;
        width:200px;
        box-shadow: inset 0px 0px 2px 2px rgba(216, 216, 216, 0.596);
        outline:none;
        border:1px solid rgb(216, 216, 216);
        padding-left:6px;
        padding-right:6px;
    }

    .tube-button {
        height: 32px;
        border-radius: 6px;
        outline:none;
        border:1px solid rgb(216, 216, 216);
        background-color:hsl(88, 50%, 53%,0.9);
        box-shadow: 0px 1px 2px 2px rgba(216, 216, 216); 
        transition: all 0.3s cubic-bezier(0.5, 0, 0.5, 1);
        padding-left:6px;
        padding-right:6px;
        cursor: pointer;
    }


    .login-background .assistButton{
        width:214px;
        display: flex;
        flex-direction: row;
        justify-content:space-between;
    }

    .login-background .assistButton button{
        width:47%;
    }

    button.wide {
        width:100%;
    }

    .tube-button:active {
        background-color:rgba(133, 204, 52, 0.9);
        box-shadow: 0px 1px 0px 0px rgba(216, 216, 216);
    }

    .tab {
        display: flex;
		flex-direction: column;
        align-content: center;
        justify-content:center;
        align-items: center;
    }

    .blank {
        height: 12px;
    }

    .version {
        position: fixed;
        bottom: 0px;
        right: 4px;
        margin:4px;
        color:grey;
        opacity: .4;
    }
</style>